export const VOTES_NOT_BEFORE_SCREENING_START = 'screening.start_at';
export const VOTES_NOT_BEFORE_SCREENING_STOP = 'screening.stop_at';
export const VOTES_NOT_BEFORE_MODE_FIXED = 'fixed';

const LEGACY_SCREENING_VALUES = {
    start_at: VOTES_NOT_BEFORE_SCREENING_START,
    stop_at: VOTES_NOT_BEFORE_SCREENING_STOP,
};

const normalizeStoredValue = value => {
    if (!value || typeof value !== 'string')
        return value;

    return LEGACY_SCREENING_VALUES[value] || value;
};

export const parseVotesNotBeforeValue = value => {
    const normalizedValue = normalizeStoredValue(value);

    if (normalizedValue === VOTES_NOT_BEFORE_SCREENING_START) {
        return {
            mode: VOTES_NOT_BEFORE_SCREENING_START,
            fixedDate: '',
            invalid: false,
        };
    }

    if (normalizedValue === VOTES_NOT_BEFORE_SCREENING_STOP) {
        return {
            mode: VOTES_NOT_BEFORE_SCREENING_STOP,
            fixedDate: '',
            invalid: false,
        };
    }

    if (!normalizedValue) {
        return {
            mode: VOTES_NOT_BEFORE_SCREENING_START,
            fixedDate: '',
            invalid: false,
        };
    }

    const parsedDate = Date.parse(normalizedValue);
    if (!isNaN(parsedDate)) {
        return {
            mode: VOTES_NOT_BEFORE_MODE_FIXED,
            fixedDate: new Date(parsedDate).toISOString(),
            invalid: false,
        };
    }

    return {
        mode: VOTES_NOT_BEFORE_MODE_FIXED,
        fixedDate: '',
        invalid: true,
        invalidRaw: normalizedValue,
    };
};

export const buildVotesNotBeforeValue = (mode, fixedDate = '') => {
    if (mode === VOTES_NOT_BEFORE_SCREENING_START)
        return VOTES_NOT_BEFORE_SCREENING_START;

    if (mode === VOTES_NOT_BEFORE_SCREENING_STOP)
        return VOTES_NOT_BEFORE_SCREENING_STOP;

    if (mode !== VOTES_NOT_BEFORE_MODE_FIXED)
        return '';

    const parsedDate = Date.parse(fixedDate);
    if (isNaN(parsedDate))
        return '';

    return new Date(parsedDate).toISOString();
};

/** Returns null when switching to fixed date without a date to commit yet. */
export const getCommittedValueOnModeChange = (nextMode, fixedDate = '') => {
    const nextValue = buildVotesNotBeforeValue(nextMode, fixedDate);

    if (nextMode === VOTES_NOT_BEFORE_MODE_FIXED && nextValue === '')
        return null;

    return nextValue;
};
